export function rankFromIndex(total: number, index: number): number {
  if (!Number.isFinite(total) || !Number.isFinite(index) || total < 1) {
    throw new Error(
      'total must be a finite number >= 1 and index must be finite'
    );
  }

  const T = Math.max(1, Math.floor(total));
  const I = Math.min(T, Math.max(1, Math.floor(index)));

  if (T === 1) return 1;

  const mid = Math.floor((T + 1) / 2);
  const k = I - 1;

  let rank: number;
  if (k === 0) {
    rank = mid;
  } else {
    const s = k % 2 === 1 ? 1 : -1;
    const magnitude = Math.ceil(k / 2);
    rank = mid + s * magnitude;
  }

  return Math.min(T, Math.max(1, rank));
}

export function positionFromRank(total: number, rank: number): number {
  if (!Number.isFinite(total) || !Number.isFinite(rank) || total < 1) {
    throw new Error(
      'total must be a finite number >= 1 and rank must be finite'
    );
  }

  const T = Math.max(1, Math.floor(total));
  const R = Math.min(T, Math.max(1, Math.floor(rank)));

  if (R <= 1) return 0;
  if (R >= T) return 1;

  const m = Math.ceil(T / 2);
  let pos: number;

  if (R <= m) {
    pos = 0.05 * (R - 1);
  } else {
    pos = 1 - 0.05 * (T - R);
  }

  return Math.round(pos * 100) / 100;
}

export function positionFromIndex(index: number, total: number): number {
  const r = rankFromIndex(total, index);
  return positionFromRank(total, r);
}

export function centermostPositions(total: number): [number, number] {
  if (!Number.isFinite(total) || total < 1) {
    throw new Error('total must be a finite number >= 1');
  }

  const T = Math.max(1, Math.floor(total));
  const leftRank = Math.floor((T + 1) / 2);
  const rightRank = Math.min(T, leftRank + 1);

  const leftPos = positionFromRank(T, leftRank);
  let rightPos = positionFromRank(T, rightRank);

  if (T === 1) {
    rightPos = 1;
  }

  return [leftPos, rightPos];
}
